export default function randomNumberUtil (min = 0, max = 1, floating = false) {
  if (floating || min % 1 || max % 1) {
    return Math.min(min + Math.random() * (max - min + parseFloat('1e-' + ((Math.random() + '').length - 1))), max)
  }
  return Math.floor(min + Math.random() * (max - min + 1))
}
